import * as React from 'react';
import { Modal, Row, Col, Card, Button, Typography } from 'antd';
import { DiscountActionTypeTarget } from 'app/shared/model';

const { Title, Paragraph } = Typography;

interface ActionTargetSelectionStepProps {
  actionTargets: DiscountActionTypeTarget[];
  isVisible: boolean;
  onSelect: (type: DiscountActionTypeTarget) => void;
  onCloseWizard: () => void;
}

export default function ActionTargetSelectionStep(
  props: ActionTargetSelectionStepProps
) {
  const { actionTargets, isVisible, onSelect, onCloseWizard } = props;

  return (
    <>
      <Button type="primary" onClick={onCloseWizard} style={{ display: 'none' }} />
      <Modal
        title="What do you want to discount?"
        open={isVisible}
        onCancel={onCloseWizard}
        footer={null}
        mask={{ closable: false }}
        destroyOnHidden
        width={800}
      >
        <Row gutter={[16, 16]} justify="center">
          {actionTargets.map(target => (
            <Col
              key={target.ShortName}
              xs={24}
              sm={12}
              md={8}
              style={{ display: 'flex' }}
            >
              <Card
                hoverable
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 250,
                  justifyContent: 'space-between'
                }}
                styles={{
                    body: {
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      paddingBottom: 0,
                    },
                  }}
                actions={[
                  <Button
                    type="link"
                    key="select"
                    onClick={() => onSelect(target)}
                    style={{ fontWeight: 500 }}
                  >
                    Select
                  </Button>
                ]}
              >
                <div style={{ flex: 1 }}>
                  <Title level={5} style={{ marginBottom: 12 }}>
                    {target.ShortName}
                  </Title>
                  <Paragraph>{target.Description}</Paragraph>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal>
    </>
  );
}
